// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__XS5G5","close":"modal_close__Jt4fD"};